import React, { Suspense } from 'react';
import { AuthCheckAdmin } from '../../Utils/AuthCheck/AdminCheck.auth';
import { ImageContainer } from '../CreateRoutes/CreateImage/CreateImage.styles';
import BreadCrumbs from '../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import HelmetHelper from '../../Components/PageHelmet/HelmetHelper.component';
import ImportantIcon from '../../Visuals/Icons/ImportantIcon.icon';
// Lazy load components
const GetPaymentInfo = React.lazy(
  () => import('./PurchasedCourses/GetPaymentInfo.component')
);
const UsersByDateRange = React.lazy(
  () => import('./UsersSignedUp/GetUsersJoinedByDate.component')
);
// const GetCoursesPurchased = React.lazy(
//   () => import('./EachCallOfInfo/GetCoursesPurchasedByDate.component')
// );

const GetInfo = () => {
  return (
    <AuthCheckAdmin>
      <HelmetHelper
        title="Information"
        description="Fetch information relating to users"
      />
      <ImageContainer>
        <BreadCrumbs one="Admin Dashboard" oneLink="/admin" two="Information" />
        <h2>Information</h2>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '1rem',
            marginTop: '1rem',
          }}
        >
          <ImportantIcon />
          <p>
            Data will be downloaded in a xlsx document. Import within an excelt
            spreadsheet to view the data.
          </p>
        </div>

        {/* Get the payment info between 2 months for users */}
        <Suspense fallback={<p>Loading payment info...</p>}>
          <GetPaymentInfo />
        </Suspense>
        {/* Get Users by date range */}
        <Suspense fallback={<p>Loading users by date range...</p>}>
          <UsersByDateRange />
        </Suspense>
        {/* Get Courses purchased by date range */}
        {/* <Suspense fallback={<p>Loading courses purchased info...</p>}>
          <GetCoursesPurchased />
        </Suspense> */}
      </ImageContainer>
    </AuthCheckAdmin>
  );
};

export default GetInfo;
